module.exports = "/shared/img/hr-blue-btn.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/hr-blue-btn.png
// module id = 3
// module chunks = 13